import axios from "axios";
import store from "@/store";
import { getToken } from "@/utils/auth";

const service = axios.create({
    baseURL: process.env.VUE_APP_KW_AUTH_BASE_URL,
    // baseURL: "",
    timeout: 500000
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        config.headers["userId"] = getToken();
        const authHeader = sessionStorage.getItem("Authorization");
        if (authHeader) {
            config.headers["Authorization"] = authHeader;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        const url = response.config.url || "";
        
        // 处理 auth/getAccessToken 响应
        if (url.includes("auth/getAccessToken")) {
            if (Number(res.code) === 200 && res.data) {
                // 存储 access_token 为 personToken
                if (res.data.access_token) {
                    sessionStorage.setItem("personToken", res.data.access_token);
                }
            }
        }
        
        // 处理 auth/getUserInfo 响应
        if (url.includes("auth/getUserInfo")) {
            if (Number(res.code) === 200 && res.data) {
                // 存储整个 data 对象为 personUserInfo
                sessionStorage.setItem("personUserInfo", JSON.stringify(res.data));
            }
        }
        
        if (Number(res.code) === 200) {
            return res;
        }
        return Promise.reject(res);
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default service;
